module.exports = __webpack_public_path__ + "static/media/our-work-title.948caaf5.jpg";